import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../template/shared/shared.module';
import { FeedbackComponent } from './feedback.component';

const FEEDBACK_ROUTE: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/dashboards', },
  { path: ':id', component: FeedbackComponent },
  { path: '**', redirectTo: '/dashboards' }
];

@NgModule({
  declarations: [
    FeedbackComponent
  ],
  imports: [
    RouterModule.forChild(FEEDBACK_ROUTE),
    SharedModule,
  ],
  providers: [
  ],
  exports: [
  ]

})

export class FeedbackModule { }
